import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, ContentContainer, TextContainer, Title, Description, Link } from './RetentionDownsellBanner.styles';
import RetentionDownsellBannerImage from './RetentionBannerImage';
import useExperienceApi from '../../hooks/useExperienceApi';
import abTests from '../../constants/abtests';
import { clickECDEvent } from '../../pages/home/homePageEcd2';
import { products, relativeUrls } from '../../constants';
import selectOffer from '../../actions/offers/select';
import updateSession from '../../actions/session/update';
import syncSession from '../../actions/session/sync';

const getFeatureContent = targetedFeature => {
  const { modalData, cta } = targetedFeature;
  const { title = 'Default Title', items = [] } = modalData ?? { title: 'Default Title', items: [] };
  const { text: linkText = 'Default Link Text' } = cta ?? { text: 'Default Link Text' };
  return { title, items, linkText };
};

const RetentionDownsellBanner = () => {
  const dispatch = useDispatch();
  const { targetedFeatures } = useExperienceApi();
  const offers = useSelector(state => state.offers);
  const session = useSelector(state => state.session);

  if (!Array.isArray(targetedFeatures) || targetedFeatures.length === 0) {
    return null;
  }

  const targetedFeature = targetedFeatures.find(f => f.agentReport?.id === abTests.PRODMOVE_PROTECT_HOOK.apiCode);
  if (!targetedFeature) {
    return null;
  }

  const { title, items, linkText } = getFeatureContent(targetedFeature);

  const handleLinkClick = e => {
    e.preventDefault();
    clickECDEvent('prodmove_switch_id_banner', 'click', 'success');

    const identityOffer = offers?.[products.identity];
    if (!identityOffer?.offerId) return;

    dispatch(selectOffer(identityOffer.offerId, products.identity));

    dispatch(
      updateSession({
        ...session,
        selectedOfferId: identityOffer.offerId,
        selectedOfferFamily: products.identity,
      })
    );
    dispatch(syncSession());

    dispatch(push(relativeUrls.switch));
  };

  return (
    <Container data-testid="retentionDownsellBanner" data-automation-test-element="retentionDownsellBanner">
      <ContentContainer>
        <RetentionDownsellBannerImage />
        <TextContainer>
          <Title>{title}</Title>
          <Description>
            {items.map(item => (
              <p key={item.id || item.title}>{item.title}</p>
            ))}
          </Description>
          <Link href="#" onClick={handleLinkClick}>
            {linkText}
          </Link>
        </TextContainer>
      </ContentContainer>
    </Container>
  );
};

export default RetentionDownsellBanner;
